export enum CodeTransformation {
    JUST_IN_TIME = 'jit',
    NONE = 'none',
}
